import cn from "classnames";
import React, { useState } from "react";

const Collapse = (props) => {
    const {
        title,
        children,
        defaultOpened = false,
        className,
        headerClassName,
        bodyClassName,
        onToggle,
        opened: controlledOpened,
    } = props;

    const isControlled = controlledOpened !== undefined;
    const [internalOpened, setInternalOpened] = useState(defaultOpened);

    const opened = isControlled ? controlledOpened : internalOpened;

    const handleToggle = () => {
        const nextOpened = !opened;
        if (!isControlled) {
            setInternalOpened(nextOpened);
        }
        if (onToggle) {
            onToggle(nextOpened);
        }
    };

    return (
        <div className={cn("collapse-wrapper", className)}>
            <div className={cn("d-flex align-items-center cursor-pointer", headerClassName)} onClick={handleToggle}>
                <div
                    className={cn("collapse-btn mr-2", {
                        "collapse-btn--down": !opened,
                        "collapse-btn--up": opened,
                    })}
                />
                {title}
            </div>
            {opened && <div className={cn("collapse-body py-2", bodyClassName)}>{children}</div>}
        </div>
    );
};

export default Collapse;
